import { IMeter } from './interfaces'
import { autoserializeAs } from 'cerialize'
import { DateSerializer } from '@/helpers/model-utils'
import { pad } from '@/helpers/strings'

export default class Meter implements IMeter {

  public static continueFrom(meter: Meter | undefined): Meter {
    const m = new Meter()
    m.floor1to5Last = meter && meter.floor1to5 || 0
    m.floor2Last = meter && meter.floor2 || 0
    m.floor3Last = meter && meter.floor3 || 0
    m.shopLast = meter && meter.shop || 0
    m.monthCode = meter && meter.nextMonthCode || ''
    return m
  }

  public static cloneFrom(meter: Meter): Meter {
    const m = new Meter()
    m.id = meter.id
    m.collectDate = meter.collectDate
    m.monthCode = meter.monthCode
    m.floor1to5Last = meter.floor1to5Last
    m.floor1to5 = meter.floor1to5
    m.floor2Last = meter.floor2Last
    m.floor2 = meter.floor2
    m.floor3Last = meter.floor3Last
    m.floor3 = meter.floor3
    m.shopLast = meter.shopLast
    m.shop = meter.shop
    return m
  }

  @autoserializeAs('id')
  public id: string = ''

  @autoserializeAs('monthCode')
  public monthCode: string = ''

  @autoserializeAs(DateSerializer, 'collectDate')
  public collectDate: Date = new Date()

  @autoserializeAs('floor1')
  public floor1to5: number = 0

  @autoserializeAs('floor2')
  public floor2: number = 0

  @autoserializeAs('floor3')
  public floor3: number = 0

  @autoserializeAs('shop')
  public shop: number = 0

  @autoserializeAs('floor1_last')
  public floor1to5Last = 0

  @autoserializeAs('floor2_last')
  public floor2Last = 0

  @autoserializeAs('floor3_last')
  public floor3Last = 0

  @autoserializeAs('shop_last')
  public shopLast = 0

  public get floor1to5Unit(): number { return this.floor1to5 - this.floor1to5Last }

  public get floor2Unit(): number { return this.floor2 - this.floor2Last }

  public get floor3Unit(): number { return this.floor3 - this.floor3Last }

  public get shopUnit(): number { return this.shop - this.shopLast }

  public get nextMonthCode(): string {
    const matched = this.monthCode.match(/(\d{4})\/(\d{2})/i)
    if (matched && matched.length >= 2) {
      const yyyy = parseInt(matched[1], 10)
      const mm = parseInt(matched[2], 10)
      if (mm === 12) {
        return `${yyyy + 1}/01`
      }
      return `${yyyy}/${pad(mm + 1, 2, '0')}`
    }
    return `Invalid source month code ${this.monthCode}`
  }

}
